export const BASE_URL = 'https://jojshop.in/';
